import Compressor from 'compressorjs';
import React from 'react';

export type Options = Omit<Compressor.Options, 'success' | 'error'>;
export type CompressFunction = (
  file: File,
  options?: Options | undefined
) => Promise<File>;

// compress function
export const compress: CompressFunction = (file, options) => {
  return new Promise((resolve, reject) => {
    new Compressor(file, {
      quality: 0.5,
      success(result) {
        if (result instanceof Blob) {
          const newFile = new File([result], file.name, {
            type: file.type,
            lastModified: file.lastModified,
          });
          resolve(newFile);
        } else {
          resolve(result);
        }
      },
      error(err) {
        reject(err);
      },
      ...options,
    });
  });
};

// hook for function-based components
export function useCompress() {
  return compress;
}

// HOC with class-based component
export function withCompress<T = void>(
  Component: React.ComponentType<T & CompressFunction>
) {
  return (props: any) => {
    const compress = useCompress();
    return <Component compress={compress} {...props} />;
  };
}
